import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRecycle,
  faLeaf,
  faGlobe,
  faHandHoldingHeart,
} from "@fortawesome/free-solid-svg-icons";
import LoginImageSrc from "../../assets/loginImage.png";
import "../../style/Login.css";

const LoginImage = ({ darkMode, t = (s) => s }) => {
  const features = [
    { icon: faRecycle, text: "Circular Economy" },
    { icon: faLeaf, text: "Reduce Waste" },
    { icon: faGlobe, text: "Global Impact" },
    { icon: faHandHoldingHeart, text: "Community Driven" },
  ];

  return (
    <div
      className={`login-image-container ${
        darkMode ? "dark-mode" : "light-mode"
      }`}
    >
      {/* Background image */}
      <img
        src={LoginImageSrc}
        alt="Sustainable materials"
        className="login-image"
      />

      {/* Gradient overlay */}
      <div className="login-image-overlay"></div>

      {/* Content overlay */}
      <div className="login-image-content">
        {/* Main headline */}
        <div className="login-image-headline">
          <h2 className="login-image-title">
            {t("Transform Waste")}
            <br />
            {t("Into Resources")}
          </h2>
          <p className="login-image-subtitle">
            {t(
              "Connecting Businesses and Recyclers on Sustainability value exchange."
            )}
          </p>
        </div>

        {/* Feature badges */}
        <div className="login-image-features">
          {features.map((feature, index) => (
            <div
              key={index}
              className="login-feature-badge"
              style={{ animationDelay: `${0.8 + index * 0.1}s` }}
            >
              <FontAwesomeIcon icon={feature.icon} />
              <span>{t(feature.text)}</span>
            </div>
          ))}
        </div>

        {/* Stats (optional - can be removed) */}
        {/* <div className="login-image-stats">
          <div className="login-stat">
            <span className="login-stat-value">500+</span>
            <span className="login-stat-label">{t("Materials Listed")}</span>
          </div>
          <div className="login-stat-divider"></div>
          <div className="login-stat">
            <span className="login-stat-value">100+</span>
            <span className="login-stat-label">{t("Active Partners")}</span>
          </div>
          <div className="login-stat-divider"></div>
          <div className="login-stat">
            <span className="login-stat-value">50k</span>
            <span className="login-stat-label">{t("Tons Diverted")}</span>
          </div>
        </div> */}
      </div>

      {/* Floating decorative elements */}
      <div className="login-floating-elements">
        <div className="login-float login-float--1">
          <FontAwesomeIcon icon={faLeaf} />
        </div>
        <div className="login-float login-float--2">
          <FontAwesomeIcon icon={faRecycle} />
        </div>
        <div className="login-float login-float--3">
          <FontAwesomeIcon icon={faGlobe} />
        </div>
      </div>
    </div>
  );
};

export default LoginImage;
